import { Component, input, InputSignal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Close (X) button placed in the top-right corner of a dialog.
 * It is appended to every opened dialog by `DialogCloseButtonService`, so it should not be added to dialog templates.
 */
@Component({
  imports: [MatIconButton, MatIcon, TranslatePipe],
  selector: 'app-dialog-close-button',
  styleUrl: './dialog-close-button.component.scss',
  templateUrl: './dialog-close-button.component.html',
})
export class DialogCloseButtonComponent {
  public dialogRef: InputSignal<MatDialogRef<unknown>> = input.required<MatDialogRef<unknown>>();

  public close(): void {
    this.dialogRef().close();
  }
}
